(async () => {
    const { Core } = await importModule('Core');
    
    customElements.define('express-option-list', class extends Core {

        elements = {
            toCartButton: 'button[data-to-cart]',
            selectedVariantPrice: '[data-selected-variant-price]',
            variantInputs: 'input[name="id"]',
            quantityInput: '[data-input]',
            form: '#express-option-list-form'
        }

        render() {
            this.addEventListener('change', this._onInputChange.bind(this));
            this.$quantityInput.addEventListener('input', this._onQuantityChange.bind(this));
        }

        _onInputChange(e) {
            if (e.target.name === 'id') {
                // Update the selected variant ID
                this.selectedVariantId = e.target.value;

                // Update the form with the selected variant ID
                this.$form.querySelector('input[name="id"]').value = this.selectedVariantId;

                // Update the price display
                this.selectedVariantPrice = e.target.dataset.price;
            }
        }

        _onQuantityChange(e) {
            const quantity = parseInt(e.target.value, 10);
            if (isNaN(quantity) || quantity < 1) {
                this.selectedQuantity = 1; // Fallback to minimum of 1
                this.$quantityInput.value = 1;
            } else {
                this.selectedQuantity = quantity;
            }

            // Update the form with the selected quantity
            this.$form.querySelector('input[name="quantity"]').value = this.selectedQuantity;
        }

        set selectedVariantPrice(value) {
            this.$selectedVariantPrice.innerText = value;
        }
    });
})();
